import { Avatar, Typography } from "antd";
import { convertToS3Link, testImage } from "../../../utility/Utils";
import React, { useEffect, useMemo, useState } from "react";
import { S3Type } from "../../../../shared/constants/AppEnums";
import clsx from "clsx";
import "./index.style.less";
import PhoneNumberItem from "../PhoneNumberItem";

const UserInfoItem = ({
  username,
  id,
  s3Profile,
  code,
  email,
  phoneNumber,
  isSizeSmall = false,
  isShowContactInfo = false,
}) => {
  const [isAvatarLoadable, setIsAvatarLoadable] = useState(false);
  const avatar = useMemo(
    () => convertToS3Link(S3Type.UID_AVATAR, id, s3Profile),
    [id, s3Profile]
  );
  useEffect(() => {
    testImage(avatar).then(
      () => setIsAvatarLoadable(true),
      () => setIsAvatarLoadable(false)
    );
  }, [avatar]);

  return (
    <div className="user-info-wrapper">
      {isAvatarLoadable
        ? avatar && (
            <Avatar
              className={clsx("cr-user-info-avatar", isSizeSmall && "small")}
              src={avatar}
            />
          )
        : username && (
            <Avatar
              className={clsx("cr-user-info-avatar", isSizeSmall && "small")}
            >
              {username.charAt(0).toUpperCase()}
            </Avatar>
          )}
      <div className="user-info-identity-wrapper">
        {username && <span>{username}</span>}
        {code && <span className="user-info-time-item">{code}</span>}
      </div>
      {isShowContactInfo && (
        <div className="user-info-contact-wrapper">
          <Typography.Text style={{ color: "#1677ff" }}>
            <PhoneNumberItem value={phoneNumber} />
          </Typography.Text>
          <Typography.Text style={{ color: "#1677ff" }}>
            {email}
          </Typography.Text>
        </div>
      )}
    </div>
  );
};

export default UserInfoItem;
